export default "__VITE_ASSET__BFVraPFC__"